/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from "react";
import "./styles.scss";

const CountDownTimer = ({ initialSeconds = 0, onCountdownEnd }) => {
  const [seconds, setSeconds] = useState(initialSeconds);

  useEffect(() => {
    if (seconds && seconds > 0) {
      const timer = setTimeout(() => {
        setSeconds((prev) => prev - 1);
      }, 1000);
      return () => clearTimeout(timer);
    }
    onCountdownEnd();
  }, [seconds]);

  const formatTime = (secs) => {
    const minutes = Math.floor(secs / 60);
    const sec = secs % 60;
    return `${minutes.toString().padStart(2, "0")}:${sec
      .toString()
      .padStart(2, "0")}`;
  };

  return <span className="count-down-text">{formatTime(seconds)}</span>;
};

export default CountDownTimer;
